"use client";

import { useEffect, useRef } from "react";
import { useAction, useQuery } from "convex/react";
import { useConvexAuth } from "convex/react";
import { toast } from "sonner";
import { api } from "@repo/backend/convex/_generated/api";
import { REFERRAL_STORAGE_KEY } from "@/lib/referral";

const ReferralAutoRedeemer = () => {
  const { isAuthenticated, isLoading } = useConvexAuth();
  const acceptReferral = useAction(api.referrals.acceptReferral);
  const onboarding = useQuery(api.onboarding.getMyOnboarding);
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (isLoading || onboarding === undefined) return;
    if (!isAuthenticated || !onboarding?.completed) return;
    if (attemptedRef.current) return;
    attemptedRef.current = true;

    const slug = typeof window !== "undefined" ? localStorage.getItem(REFERRAL_STORAGE_KEY) : null;
    if (!slug) return;

    const redeem = async () => {
      try {
        const result = await acceptReferral({ slug });
        if (result?.success) {
          toast.success(result.message ?? "Referral reward applied.");
        } else if (result?.message) {
          toast(result.message);
        }
      } catch (error) {
        console.error("Failed to auto-redeem referral", error);
        toast.error("We couldn't apply your referral reward. Please try again later.");
      } finally {
        if (typeof window !== "undefined") {
          localStorage.removeItem(REFERRAL_STORAGE_KEY);
        }
      }
    };

    void redeem();
  }, [isAuthenticated, isLoading, onboarding, acceptReferral]);

  return null;
};

export default ReferralAutoRedeemer;
